import RightCheveron from '@/components/Icons/RightCheveron';
import Link from 'next/link';

export default function BackButton({
  href,
  addClassStyles,
}: {
  href: string;
  addClassStyles?: string;
}) {
  return (
    (<Link href={href} className={`flex items-center group ${addClassStyles}`}>

      <div className="transform rotate-180">
        <RightCheveron />
      </div>
      <div className="ml-1.6 font-medium text-s">BACK</div>

    </Link>)
  );
}
